<template>
  <div class="between_item between_right">
    <CardWeather v-if="curSideTab == 'home'"></CardWeather>
    <CardBySide1 v-if="curSideTab == '发电机组'"></CardBySide1>
    <CardBySide2 v-if="curSideTab == '辅机设备'"></CardBySide2>
    <CardBySide3 v-if="curSideTab == '视频监控'"></CardBySide3>
    <CardBySide4 v-if="curSideTab == '水工建筑'"></CardBySide4>
    <CardBySide5 v-if="curSideTab == '参观培训'"></CardBySide5>
  </div>
</template>

<script>
import CardWeather from './CardWeather.vue';
import CardBySide1 from './CardBySide1.vue';
import CardBySide2 from './CardBySide2.vue';
import CardBySide3 from './CardBySide3.vue';
import CardBySide4 from './CardBySide4.vue';
import CardBySide5 from './CardBySide5.vue';
import EventBus from '@/eventBus.ts';
export default {
  name: 'RightBoxOne',
  components: {
    CardWeather,
    CardBySide1,
    CardBySide2,
    CardBySide3,
    CardBySide4,
    CardBySide5,
  },
  data() {
    return {
      curSideTab: 'home',
    };
  },
  mounted() {
    EventBus.$on('curSideTab', (data) => {
      console.log('data :>> ', data);
      this.curSideTab = data;
    });
  },
};
</script>

<style lang="scss" scoped>
.between_item {
  width: 480px;
}
</style>
